const state = {
  demands: [],
  actionRecommendations: [],
  currentActionRecommendation: null,
  currentDemandDetails: null,
  currentDemandRecords: [],
  statesByDescription: {},
  filtersConfig: null,
  pagination: {
    range: null,
    stopLoad: false,
    filters: null
  }
}

export default state
